import { ReactComponent as BonanzaLogo } from './bonanza-logo.svg';
import { ReactComponent as article } from './article.svg';
import { ReactComponent as arrowForward } from './arrow-forward.svg';
import { ReactComponent as arrowForwardOutlined } from './arrow-forward-outlined.svg';
import { ReactComponent as arrowForwardIosOutlined } from './arrow-forward-ios-outlined.svg';
import { ReactComponent as arrowBackwardIosOutlined } from './arrow-backward-ios-outlined.svg';
import { ReactComponent as arrowDropDown } from './arrow_drop_down.svg';
import { ReactComponent as faceId } from './face-id.svg';
import { ReactComponent as touchId } from './touch-id.svg';
import { ReactComponent as favoriteFilled } from './favorite-filled.svg';
import { ReactComponent as favoriteBorderFilled } from './favorite-border-filled.svg';
import { ReactComponent as GamesTab } from './games-tab.svg';
import { ReactComponent as HomeTab } from './home-tab.svg';
import { ReactComponent as AccountTab } from './account-tab.svg';
import { ReactComponent as lockFilled } from './lock-filled.svg';
import { ReactComponent as search } from './search.svg';
import { ReactComponent as close } from './close.svg';
import { ReactComponent as home } from './home.svg';
import { ReactComponent as chat } from './chat.svg';
import { ReactComponent as chatWidget } from './chat-widget.svg';
import { ReactComponent as tickets } from './tickets.svg';
import { ReactComponent as user } from './user.svg';
import { ReactComponent as send } from './send.svg';
import { ReactComponent as star } from './star.svg';
import { ReactComponent as attach } from './attach.svg';
import { ReactComponent as document } from './document.svg';
import { ReactComponent as likeThumb } from './like-thumb.svg';
import { ReactComponent as unlikeThumb } from './unlike-thumb.svg';
import { ReactComponent as photoLibrary } from './photo-library.svg';
import { ReactComponent as photoCamera } from './photo-camera.svg';
import { ReactComponent as chooseFile } from './choose-file.svg';
import { ReactComponent as check } from './check.svg';
import { ReactComponent as edit } from './edit.svg';
import { ReactComponent as info } from './info.svg';
import { ReactComponent as arrowBack } from './arrow-back.svg';
import { ReactComponent as arrowBackOutlined } from './arrow-back-outlined.svg';
import { ReactComponent as checkbox } from './check_box_outline_blank.svg';
import { ReactComponent as checkboxChecked } from './check_box.svg';
import { ReactComponent as bonanzaCoin } from './bonanza-coin.svg';
import { ReactComponent as bonanzaDollar } from './bonanza-dollar.svg';
import { ReactComponent as slotsDark } from './slots-dark.svg';
import { ReactComponent as bonanzaWallet } from './bonanza-wallet.svg';
import { ReactComponent as spinWheel } from './spin-wheel.svg';
import { ReactComponent as freeSpins } from './free-spins.svg';
import { ReactComponent as rewardWheel } from './reward-wheel.svg';
import { ReactComponent as errorOutline } from './error-outline.svg';
import { ReactComponent as fileUpload } from './file-upload.svg';
import { ReactComponent as fingerprint } from './fingerprint.svg';
import { ReactComponent as inboxBell } from './inbox-bell.svg';
import { ReactComponent as jpg } from './jpg.svg';
import { ReactComponent as jpeg } from './jpeg.svg';
import { ReactComponent as png } from './png.svg';
import { ReactComponent as heic } from './heic.svg';
import { ReactComponent as accountCircle } from './account_circle.svg';
import { ReactComponent as lock } from './lock.svg';
import { ReactComponent as paid } from './paid.svg';
import { ReactComponent as priceCheck } from './price_check.svg';
import { ReactComponent as timelapse } from './timelapse.svg';
import { ReactComponent as inviteFriend } from './invite_friend.svg';
import { ReactComponent as percent } from './percent.svg';
import { ReactComponent as shoppingBag } from './shopping-bag.svg';
import { ReactComponent as flame } from './flame.svg';
import { ReactComponent as sortArrows } from './sort-arrows.svg';
import { ReactComponent as quest } from './quest.svg';
import { ReactComponent as visa } from './visa.svg';
import { ReactComponent as mastercard } from './mastercard.svg';
import { ReactComponent as socialFb } from './social-fb.svg';
import { ReactComponent as socialIg } from './social-ig.svg';
import { ReactComponent as socialTt } from './social-tt.svg';
import { ReactComponent as socialLdin } from './social-ldin.svg';
import { ReactComponent as socialYoutube } from './social-youtube.svg';
import { ReactComponent as socialTg } from './social-telegram.svg';
import { ReactComponent as visaCard } from './visa-card.svg';
import { ReactComponent as masterCard } from './mastercard-card.svg';
import { ReactComponent as plus19 } from './19-plus.svg';
import { ReactComponent as targetArrow } from './target-arrow.svg';
import { ReactComponent as timer } from './timer.svg';
import { ReactComponent as visibility } from './visible.svg';
import { ReactComponent as visibilityOff } from './notVisible.svg';
import { ReactComponent as warning } from './warning.svg';
import { ReactComponent as checkCircle } from './check-circle.svg';
import { ReactComponent as whatsUp } from './whats-up-social.svg';
import { ReactComponent as sms } from './sms-social.svg';
import { ReactComponent as email } from './email-social.svg';
import { ReactComponent as contentCopy } from './content_copy.svg';
import { ReactComponent as sparkle } from './sparkle.svg';
import { ReactComponent as applePay } from './apple-pay.svg';
import { ReactComponent as redLeaf } from './red-leaf.svg';
import { ReactComponent as appStore } from './app-store.svg';
import { ReactComponent as plusReward } from './plus-reward.svg';
import { ReactComponent as mapleLeafs } from './maple-leafs.svg';
import { ReactComponent as torontoRaptors } from './toronto-raptors.svg';
import { ReactComponent as supportAgent } from './support-agent.svg';
import { ReactComponent as mysteryBox } from './mystery-box.svg';
import { ReactComponent as apparel } from './apparel.svg';

import { ReactComponent as amethystGemOutline } from './status/amethyst-gem-outline.svg';
import { ReactComponent as aquamarineGemOutline } from './status/aquamarine-gem-outline.svg';
import { ReactComponent as diamondGemOutline } from './status/diamond-gem-outline.svg';
import { ReactComponent as emeraldGemOutline } from './status/emerald-gem-outline.svg';
import { ReactComponent as opalGemOutline } from './status/opal-gem-outline.svg';
import { ReactComponent as rubyGemOutline } from './status/ruby-gem-outline.svg';
import { ReactComponent as sapphireGemOutline } from './status/sapphire-gem-outline.svg';
import { ReactComponent as topazGemOutline } from './status/topaz-gem-outline.svg';
import { ReactComponent as vipGemOutline } from './status/vip-gem-outline.svg';
import { ReactComponent as maintenance } from './maintenance.svg';
import { ReactComponent as cancel } from './cancel.svg';
import { ReactComponent as bonanzaCoinGold } from './bonanza-coin-golden.svg';
import { ReactComponent as bonanzaCoinBlack } from './bonanza-coin-black.svg';

import { ReactComponent as addToHomeIcon } from './add-to-home.svg';
import { ReactComponent as share } from './share.svg';
import { ReactComponent as link } from './link.svg';
import { ReactComponent as scratchcards } from './scratchcards.svg';
import { ReactComponent as metaWheel } from './meta-wheel.svg';

export default {
  BonanzaLogo,
  article,
  arrowForward,
  arrowForwardOutlined,
  arrowForwardIosOutlined,
  arrowBackwardIosOutlined,
  arrowDropDown,
  faceId,
  touchId,
  favoriteFilled,
  favoriteBorderFilled,
  GamesTab,
  HomeTab,
  AccountTab,
  lockFilled,
  search,
  close,
  home,
  chat,
  chatWidget,
  tickets,
  user,
  send,
  star,
  attach,
  document,
  likeThumb,
  unlikeThumb,
  photoLibrary,
  photoCamera,
  chooseFile,
  check,
  edit,
  info,
  arrowBack,
  arrowBackOutlined,
  checkbox,
  checkboxChecked,
  bonanzaCoin,
  bonanzaDollar,
  slotsDark,
  spinWheel,
  freeSpins,
  rewardWheel,
  bonanzaWallet,
  errorOutline,
  fileUpload,
  fingerprint,
  inboxBell,
  jpg,
  jpeg,
  png,
  heic,
  quest,
  visa,
  mastercard,
  accountCircle,
  lock,
  paid,
  priceCheck,
  timelapse,
  inviteFriend,
  percent,
  shoppingBag,
  flame,
  sortArrows,
  socialFb,
  socialIg,
  socialTt,
  socialLdin,
  socialYoutube,
  socialTg,
  visaCard,
  masterCard,
  plus19,
  targetArrow,
  timer,
  visibility,
  visibilityOff,
  warning,
  checkCircle,
  whatsUp,
  sms,
  email,
  contentCopy,
  sparkle,
  applePay,
  redLeaf,
  appStore,
  plusReward,
  mapleLeafs,
  torontoRaptors,
  supportAgent,
  mysteryBox,
  apparel,
  AmethystGemOutline: amethystGemOutline,
  AquamarineGemOutline: aquamarineGemOutline,
  DiamondGemOutline: diamondGemOutline,
  EmeraldGemOutline: emeraldGemOutline,
  OpalGemOutline: opalGemOutline,
  RubyGemOutline: rubyGemOutline,
  SapphireGemOutline: sapphireGemOutline,
  TopazGemOutline: topazGemOutline,
  VipGemOutline: vipGemOutline,
  maintenance,
  cancel,
  bonanzaCoinGold,
  bonanzaCoinBlack,
  addToHomeIcon,
  share,
  link,
  scratchcards,
  metaWheel,
};
